export const API_VERSION = 24;
/**
 * This should be equal to the ID of the most recent migration in the client schema.
 */
export const SCHEMA_VERSION = 19;
export const ADMIN_USER_ID = "00000000-0000-0000-0000-000000000000";
export const ADMIN_ORGANIZATION_ID = ADMIN_USER_ID;
export const LEVELS_ORGANIZATION_ID = "786bf9c4-f0e1-50e6-b814-9e096ebc1a1c";
